import { render } from "./IconTrekCustomizable.vue?vue&type=template&id=556a7dde"
import script from "./IconTrekCustomizable.vue?vue&type=script&lang=js"
export * from "./IconTrekCustomizable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__